import { render, staticRenderFns } from "./Crop.vue?vue&type=template&id=35acddd3&scoped=true"
import script from "./Crop.vue?vue&type=script&lang=js"
export * from "./Crop.vue?vue&type=script&lang=js"
import style0 from "./Crop.vue?vue&type=style&index=0&id=35acddd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35acddd3",
  null
  
)

export default component.exports